// import { nextTick } from 'vue';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export default {
  install: (app, options) => {
    const defaultSettings = {
      debug: false,
      headerHeight: 0,
      linkSelector: 'data-scroll-link'
    };

    const settings = Object.assign(defaultSettings, options);

    const initSectionsLinks = () => {
      const sections = document.querySelectorAll('[data-scroll-section]');
      const links = document.querySelectorAll(`[${settings.linkSelector}]`);

      if (links.length) {
        sections.forEach(section => {
          ScrollTrigger.create({
            trigger: `[data-scroll-section="${section.dataset.scrollSection}"]`,
            markers: settings.debug,
            start: `0% ${settings.headerHeight + 50}px`,
            end: `100% ${settings.headerHeight + 50}px`,
            onEnter: (self) => {
              activateLinks(`[${settings.linkSelector}="${section.dataset.scrollSection}"]`);
            },
            onEnterBack: (self) => {
              activateLinks(`[${settings.linkSelector}="${section.dataset.scrollSection}"]`);
            },
            onLeave: (self) => {
              deactivateLinks(`[${settings.linkSelector}="${section.dataset.scrollSection}"]`);
            },
            onLeaveBack: (self) => {
              deactivateLinks(`[${settings.linkSelector}="${section.dataset.scrollSection}"]`);
            },
          });
        });
      }
    };

    const activateLinks = (el) => {
      const buttons = document.querySelectorAll(el);
      buttons.forEach(button => {
        button.classList.add('active');
      });
    }

    const deactivateLinks = (el) => {
      const buttons = document.querySelectorAll(el);
      buttons.forEach(button => {
        button.classList.remove('active');
      });
    }

    const goTo = (section, callback) => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: `[data-scroll-section="${section}"]`,
          offsetY: settings.headerHeight
        },
        // onComplete: () => {
        //   removeParam("goto")
        // }
      });
    };

    const getParam = (param) => {
      var result = null,
        tmp = [];

      location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
        });

      if (result === 'undefined') {
        return null
      } else {
        return result
      }
    }

    const removeParam = (key) => {
      const sourceURL = location.protocol + '//' + location.host + location.pathname
      var urlparts = window.location.search.split('?')

      if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(key) + '='
        var pars = urlparts[1].split(/[&;]/g)

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1)
          }
        }

        window.history.replaceState(null, null, sourceURL + urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''))
      }
    }

    const paramSection = getParam('section');

    if (paramSection) {
      goTo(paramSection);
      removeParam('section');
    }

    const scrollTo = { initSectionsLinks, goTo };

    app.config.globalProperties.$scrollTo = scrollTo;
    app.provide('$scrollTo', scrollTo);
  }
}